import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  InputAdornment,
  Alert,
} from "@mui/material";
import { AccountCircle, Lock } from "@mui/icons-material";
import { MaviTrackrLogo } from "assets/images";
import { AuthContext } from "navigation/AuthProvider";
import { useForm } from "react-hook-form";
import { IDataLogin, ILoginEmployee } from "models/Employee";
// import LoginController from "api/LoginController";
import fetchApi from "api/fetchApi";

const LoginForm = () => {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState(null);
  const form = useForm<ILoginEmployee>();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form;
  const { login } = useContext(AuthContext);
  const [loading, setLoading] = useState<boolean>(false);

  const signIn = async () => {
    setError(null);
    setLoading(true);

    if (!username || !password) {
      setError("Username and password are required");
      setLoading(false);
      return;
    }

    try {
      const response = await fetchApi("login").post("login", {
        user_matricule: username,
        password,
      });

      console.log("Response:", response);

      if (response.data.token) {
        login(response as IDataLogin);
        console.log("Token retrieved Successfully", response.data.token);
      } else {
        setError("Invalid Credentials");
      }
    } catch (error) {
      console.error("Error while logging in:", error);
      setError("Error while logging in");
    } finally {
      setLoading(false);
    }
  };



  return (
    <Grid item xs={12} sm={12} md={5.5}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Paper elevation={3} sx={{ padding: 4 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img src={MaviTrackrLogo} alt="Mavitrackr Logo" width={100} height={100} />
            <Typography variant="h1" sx={{ color: "#146ED2", fontSize: "36px", fontWeight: 600 }}>
              MaviTrackr
            </Typography>
          </Box>
          <Typography
            variant="h4"
            sx={{
              color: "#146ED2",
              marginTop: "30px",
              marginBottom: "30px",
              fontSize: "36px",
              fontWeight: 600,
            }}
          >
            Welcome Back
          </Typography>
          <form onSubmit={handleSubmit(signIn)}>
            <TextField
              label="Username"
              placeholder="Enter your Username"
              margin="normal"
              fullWidth
              autoComplete="on"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              }}
              sx={{ backgroundColor: "#F6F6F6" }}
              {...register("username", { required: "Username is required" })}
              error={!!errors.username}
              helperText={errors.username?.message}
              defaultValue={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              label="Password"
              type="password"
              placeholder="Enter your Password"
              margin="normal"
              fullWidth
              autoComplete="off"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
              }}
              sx={{ backgroundColor: "#F6F6F6", marginTop: "30px" }}
              {...register("password", { required: "Password is required" })}
              error={!!errors.password}
              helperText={errors.password?.message}
              defaultValue={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Typography
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                color: "#146ED2",
                fontSize: "15px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Forgot Password ?
            </Typography>
            {error && (
              <Alert severity="error" sx={{ marginTop: "10px" }}>
                {error}
              </Alert>
            )}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{
                marginTop: "50px",
                marginBottom: "50px",
                padding: "10px",
                fontWeight: 600,
                borderRadius: "4px",
              }}
              onClick={signIn}
            >
              {loading ? "Logging In..." : "Login"}
            </Button>
          </form>
        </Paper>
      </Box>
    </Grid>
  );
};

export default LoginForm;
